import openhouseAPI from "../services/openhouse";
import queryClient from "../services/reactQuery";
import { getLocalData, storeLocalData } from "../services/storage";

export interface InputCreateOpenHouse {
  openHouse: {
    uuid: string;
    organization_uuid: string;
    host_user_uuid: string;
    created_by_user_uuid: string;
    property_id: string;
    form_uuid: string | null;
    instructions: string;
    start_date: string;
    start_time: string;
    end_date: string;
    end_time: string;
    is_pending: boolean;
    manual_attendee_count: number;
    is_active: false;
    active_at: string | null;
  };
  tags: string[];
  propertyDetails: {
    street_address: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
  };
  pingTime: number | null;
}

const useCreateOpenHouse = async (
  inputCreateOpenHouse: InputCreateOpenHouse
) => {
  openhouseAPI
    .put("/openhouse/save", inputCreateOpenHouse)
    .then(async (res) => {
      await queryClient.invalidateQueries(["openHouses"]);
      await queryClient.invalidateQueries(["dashboardStats"]);
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export default useCreateOpenHouse;
